<script lang="ts">
    import { onMount } from "svelte";
    import { Word } from "../../dictionary/Word";
    import Collection from "../../materialize/components/Collection.svelte";
    import CollectionItem from "../../materialize/components/CollectionItem.svelte";
    import Column from "../../materialize/grid/Column.svelte";
    import Row from "../../materialize/grid/Row.svelte";
    import Spinner from "../../utils/Spinner.svelte";
    import { current_dialect, italian_language, is_online } from "../../stores/stores";
    import { get_host } from "../../settings";
    import WordDetails from "./WordDetails.svelte";
import WordAudioButton from "./WordAudioButton.svelte";
    export let word_to_translate: Word;
    let promise_translations = fetch(
        get_host() +
            `/api/dictionary/word/${word_to_translate.id}/translate/${
                word_to_translate.language === $current_dialect.id
                    ? $italian_language.id
                    : $current_dialect.id
            }`
    )
        .then((res) => {
            return res.json();
        })
        .then((arr) => {
            let search_results = [];
            arr.forEach((el) => {
                console.log(el);
                search_results.push(new Word(el));
            });
            return search_results;
        }).catch(()=>{$is_online = false;});
</script>

{#await promise_translations}
    <Spinner />
{:then response_list}
    <Collection header={true}>
        <CollectionItem header="{true}">
            <h5>Traduzioni di "{word_to_translate.word}":
                <WordAudioButton word={word_to_translate}>
                </WordAudioButton>
            </h5>
        </CollectionItem>
        {#each response_list as word}
            <CollectionItem>
                <WordDetails {word}></WordDetails>
            </CollectionItem>
        {/each}
    </Collection>
{/await}
